var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "language-list-card", attrs: { href: _vm.itemUrl } },
    [
      _c("span", {
        staticClass: "language-list-card-label",
        attrs: { lang: _vm.item.regionalIsoCode },
        domProps: {
          innerHTML: _vm._s(
            _vm.parsedLanguageLabel
              ? _vm.parsedLanguageLabel
              : _vm.item.displayName
          ),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }